export enum torch_state {
    on,
    off
}